module.exports = function($) {
    class collapse {

        constructor(params) {
            this.multiple = true;
            if( typeof (params.multiple) != "undefined" && params.multiple ){
                this.multiple = false;
            }
            this.classname = params.classname;
            this.collapse = $(this.classname);
            this.callback = params.callback;
            this.self = params.self;
            this.bind();
        }

        bind() {
            let collapse = this.collapse;
            let multiple = this.multiple;
            let _this = this;
            $('body').on('click', this.classname + ' .collapse-button' , function () {
                let controls = $(this).attr('aria-controls');
                let expanded =  $(this).attr('aria-expanded');

                let active = $(this).hasClass('collapse-open');

                if( multiple ){
                    collapse.find('.collapse-open').removeClass('collapse-open');
                    collapse.find('.collapse-button').attr('aria-expanded', false);
                }

                if( expanded == "false" ){
                    $(this).attr('aria-expanded', true);
                } else {
                    $(this).attr('aria-expanded', false);
                }

                if( active ){
                    if( _this.self == false ){
                        $(this).addClass('collapse-open');
                        $(_this.classname + ' [aria-controls="'+controls+'"]').addClass('collapse-open');
                        $('#'+controls).addClass('collapse-open');
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).removeClass('collapse-open');
                        $(_this.classname + ' [aria-controls="'+controls+'"]').removeClass('collapse-open');
                        $('#'+controls).removeClass('collapse-open');
                    }
                } else {
                    $(this).addClass('collapse-open');
                    $(_this.classname + ' [aria-controls="'+controls+'"]').addClass('collapse-open');
                    $('#'+controls).addClass('collapse-open');
                }

                _this.callback();
            })
        }
    }

    new collapse({
        "classname": '.teams__items',
        'multiple': false,
        'self': true,
        'callback': function () {

        }
    });


    new collapse({
        "classname": '.jobs_nav',
        'multiple': true,
        'self': true,
        'callback': function () {

        }
    });

    new collapse({
        "classname": '.tabs-items',
        'multiple': false,
        'self': false,
        'callback': function () {

        }
    });

    new collapse({
        'classname': '.interactive-map',
        'multiple':false,
        'self': true,
        'callback': function () {
            $('body').toggleClass('NoScroll');
        }
    })

    /*
        JOBS
     */
    $(".jobs_nav ul li button").on('click', function(){
        $(".jobs_nav ul li button").removeClass('active');
        $(".jobs__detail__content ").removeClass('active');
        $(this).addClass('active');
        let id = $(this).attr('aria-controls');
        $("#" + id).addClass('active');
    })

    $('.block.tabs .tabs-items .tabs-nav').on('click', function () {
        $(this).toggleClass('open');
    })

}
